<div class="mb-3">
    <h3>WFS koppeling</h3>
    <p>
        Via de WFS koppeling (Web Feature Service) kun je de werkvakken als punten inladen in GIS-software zoals QGIS of
        ArcGIS. De gegevens worden live opgehaald: wijzigingen in de planning zijn na het verversen van de laag direct
        zichtbaar. De koppeling is alleen-lezen.
    </p>

    <h5>Wat zit er in de laag?</h5>
    <ul>
        <li>Laag <code>planning:workarea</code>: één punt per werkvak (WGS84, EPSG:4326).</li>
        <li>
            Velden: nummer, status, schade, locatie schade, afzetting, markering, toplaag, tussenlaag, onderlaag en
            uitvoering (dag/nacht).
        </li>
        <li>Booropdrachten komen alleen mee als je het betreffende project kiest.</li>
        <li>Formaten: GML 3.2 (standaard) of GeoJSON.</li>
    </ul>

    <h5>URL samenstellen</h5>
    <div class="row mb-3">
        @if (customers().length > 1) {
            <div class="col-24 col-md-12 mb-2">
                <ng-select
                    [items]="customers()"
                    [ngModel]="customerId()"
                    (ngModelChange)="selectCustomer($event)"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="Klant"></ng-select>
            </div>
        }
        <div class="col-24 col-md-12 mb-2">
            <ng-select
                [items]="projects()"
                [ngModel]="projectId()"
                (ngModelChange)="projectId.set($event)"
                [disabled]="!customerId()"
                bindLabel="name"
                bindValue="id"
                placeholder="Project (optioneel, alle projecten)">
                <ng-template ng-option-tmp let-item="item">
                    {{ item.name }}
                    @if (item.type === 'drillings') {
                        <span class="text-muted">(booropdracht)</span>
                    }
                </ng-template>
            </ng-select>
        </div>
    </div>

    <p>
        Voor de koppeling is een persoonlijke WFS-token nodig. Deze token is
        <b>1 jaar geldig</b> en geeft alleen leestoegang tot de WFS koppeling van de gekozen klant. Voor een andere
        klant genereer je een nieuwe token. Behandel de URL als een wachtwoord en deel hem niet. Een nieuwe token maakt
        eerder gegenereerde tokens niet ongeldig.
    </p>
    <button
        class="mb-3"
        [disabled]="!customerId() || generating()"
        (click)="generateToken()"
        color="primary"
        mat-raised-button>
        {{ generating() ? 'Token genereren...' : token() ? 'Nieuwe token genereren' : 'Token genereren' }}
    </button>

    @if (wfsUrl()) {
        <div class="mb-3">
            <div class="text-muted small">
                WFS URL (QGIS / ArcGIS), geldig tot {{ token().expires_at | date: 'd MMMM yyyy' }}
            </div>
            <div class="d-flex align-items-center">
                <code class="text-break flex-grow-1">{{ wfsUrl() }}</code>
                <button (click)="copy(wfsUrl(), 'wfs')" class="ms-2" mat-stroked-button>
                    {{ copied() === 'wfs' ? 'Gekopieerd' : 'Kopiëren' }}
                </button>
            </div>
        </div>
        <div class="mb-3">
            <div class="text-muted small">GeoJSON URL (direct inladen, max. 1000 punten)</div>
            <div class="d-flex align-items-center">
                <code class="text-break flex-grow-1">{{ geojsonUrl() }}</code>
                <button (click)="copy(geojsonUrl(), 'geojson')" class="ms-2" mat-stroked-button>
                    {{ copied() === 'geojson' ? 'Gekopieerd' : 'Kopiëren' }}
                </button>
            </div>
        </div>
    }

    <h5>QGIS</h5>
    <ol>
        <li>Kies <i>Kaartlagen → Laag toevoegen → WFS / OGC API - Features laag toevoegen</i>.</li>
        <li>Klik op <i>Nieuw</i>, geef de verbinding een naam en plak de WFS URL bij <i>URL</i>.</li>
        <li>Laat de overige instellingen op standaard staan (versie <i>Maximum</i> of <i>2.0</i>).</li>
        <li>Klik op <i>Verbinden</i>, selecteer de laag <i>Werkvakken</i> en klik op <i>Toevoegen</i>.</li>
    </ol>
    <p>
        Liever geen token in de URL? Gebruik dan <code>{{ baseUrl() }}</code> als URL en voeg bij
        <i>Authenticatie</i> een configuratie van het type <i>API Header</i> toe met header
        <code>Authorization</code> en waarde <code>Bearer &lt;token&gt;</code>.
    </p>

    <h5>ArcGIS Pro</h5>
    <ol>
        <li>Kies <i>Insert → Connections → Server → New WFS Server</i>.</li>
        <li>Plak de WFS URL bij <i>Server URL</i> en kies versie <i>2.0.0</i>.</li>
        <li>Voeg de laag <i>Werkvakken</i> toe vanuit de nieuwe verbinding in het <i>Catalog</i>-paneel.</li>
    </ol>

    <h5>Aandachtspunten</h5>
    <ul>
        <li>
            Liggen de punten gespiegeld (bijvoorbeeld bij Somalië in plaats van Nederland)? Zet dan in de verbinding de
            optie voor het omdraaien van de assenvolgorde aan.
        </li>
        <li>Per verzoek worden maximaal 1000 punten opgehaald; QGIS en ArcGIS halen de rest automatisch op.</li>
        <li>Is de token verlopen, genereer dan een nieuwe token en werk de URL in de verbinding bij.</li>
    </ul>
</div>
